// Poznámky + tagy k hráči v poolu (Fáze 2).
import React, { useState } from "react";
import { toast } from "sonner";
import { patchPoolEntry } from "../../lib/lab-api";

export const PRESET_TAGS = ["Safe", "Upside", "Differential", "Minutes Risk", "Fixture Pick",
    "Long-term", "Short-term", "Captaincy", "Bench Option"];

const inputCls = "w-full bg-black/40 border border-white/15 px-2 py-1.5 font-mono text-[11px] focus:outline-none focus:border-fa-mint placeholder:text-white/25";

export default function PoolNotesDialog({ entry, onDone, onCancel }) {
    const [notes, setNotes] = useState({ ...(entry.notes || {}) });
    const [tags, setTags] = useState([...(entry.tags || [])]);
    const [busy, setBusy] = useState(false);
    const set = (k) => (e) => setNotes({ ...notes, [k]: e.target.value });
    const toggleTag = (t) => setTags(tags.includes(t) ? tags.filter((x) => x !== t) : [...tags, t]);

    const save = async () => {
        setBusy(true);
        try {
            await patchPoolEntry(entry.id, { notes, tags });
            toast.success("Poznámky uloženy");
            onDone();
        } catch (e) { toast.error(e.response?.data?.detail || "Uložení selhalo"); }
        finally { setBusy(false); }
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4" onClick={onCancel} data-testid="pool-notes-dialog">
            <div className="bg-[#0b0b0b] border border-fa-mint/40 p-5 w-full max-w-md space-y-3" onClick={(e) => e.stopPropagation()}>
                <div>
                    <div className="font-mono text-[9px] uppercase tracking-widest text-fa-mint">Scouting poznámky</div>
                    <div className="font-display font-black uppercase text-lg">{entry.name}</div>
                </div>
                <label className="block font-mono text-[8px] uppercase tracking-widest text-white/40 space-y-0.5">
                    <div>Důvod zájmu</div>
                    <input value={notes.reason || ""} onChange={set("reason")} placeholder="proč ho sleduju…" className={inputCls} data-testid="pool-notes-reason" />
                </label>
                <label className="block font-mono text-[8px] uppercase tracking-widest text-white/40 space-y-0.5">
                    <div>Hlavní riziko</div>
                    <input value={notes.risk || ""} onChange={set("risk")} placeholder="rotace, zranění…" className={inputCls} data-testid="pool-notes-risk" />
                </label>
                <label className="block font-mono text-[8px] uppercase tracking-widest text-white/40 space-y-0.5">
                    <div>Plánované období</div>
                    <input value={notes.period || ""} onChange={set("period")} placeholder="GW1–6…" className={inputCls} data-testid="pool-notes-period" />
                </label>
                <label className="block font-mono text-[8px] uppercase tracking-widest text-white/40 space-y-0.5">
                    <div>Poznámka</div>
                    <textarea value={notes.note || ""} onChange={set("note")} rows={2} className={inputCls} data-testid="pool-notes-note" />
                </label>
                <div className="font-mono text-[8px] uppercase tracking-widest text-white/40">Tagy</div>
                <div className="flex flex-wrap gap-1.5">
                    {PRESET_TAGS.map((t) => (
                        <button key={t} type="button" onClick={() => toggleTag(t)} data-testid={`pool-tag-${t.toLowerCase().replace(/\s+/g, "-")}`}
                                className={`font-mono text-[9px] uppercase px-2 py-1 border transition-colors ${tags.includes(t) ? "bg-fa-mint text-black border-fa-mint font-bold" : "border-white/15 text-white/50 hover:text-white"}`}>
                            {t}
                        </button>
                    ))}
                </div>
                <div className="flex gap-2 pt-1">
                    <button type="button" onClick={save} disabled={busy} data-testid="pool-notes-save"
                            className="font-mono text-[10px] uppercase tracking-widest px-4 py-2 bg-fa-mint text-black font-bold disabled:opacity-40">
                        {busy ? "Ukládám…" : "Uložit"}
                    </button>
                    <button type="button" onClick={onCancel} className="font-mono text-[10px] uppercase tracking-widest px-3 py-2 border border-white/15 text-white/60">
                        Zavřít
                    </button>
                </div>
            </div>
        </div>
    );
}
